import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { VAM_SERVICE } from '@eggplant/api-hosts'
import type {
  Error,
  GetGitRefsResponse
} from '@eggplant/types'

interface Props {
  id: string
  onError?: (error: Error) => void
  onSuccess?: (data: GetGitRefsResponse) => void
  children?: (data: GetGitRefsResponse) => void
}

const GetGitCredentialRequest = ({
  id,
  onError,
  onSuccess,
  children
}: Props) => {
  const url = `${VAM_SERVICE}/repositories/refs/${id}`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onError={onError}
      onSuccess={onSuccess}
      url={url}
    />
  )
}

export default GetGitCredentialRequest
